<template lang="pug">
button(
    @click="onClick"
    :class="addClass"
    :disabled="isDisabled"
    :style="addStyle"
).buttonLink
    | {{ label }}
    i(v-if="isIcon").icon

</template>

<script setup>
    const props = defineProps({
        label: {
            type: String,
            default: ''
        },
        addClass: {
            type: String,
            default: ''
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        addStyle: {
            type: String,
            default: ''
        },
        isIcon: {
            type: Boolean,
            default: false
        }
    })

    const emits = defineEmits(['onClick'])

    /**
     * 押下された際の振る舞い
     * @returns {void}
     */
    function onClick() {
        emits('onClick')
    }

</script>

<style lang="stylus" scoped>
.buttonLink
    flex: none
    flex-grow: 0
    align-self: stretch
    order: 0
    font-size: 1.4rem
    line-height: 180%
    letter-spacing: .04em
    font-style: normal
    font-weight: 400
    display: inline-flex
    gap: .5rem
    align-items: center
    justify-content: center
    min-width: 24rem
    height: 6rem
    padding: 0 1.6rem
    border-radius: 2rem
    outline: none
    transition: all .3s linear

    .icon
        position: relative

    +reduced-motion()
        transition: none

    .--large
        min-width: 30.4rem

    +sp()
        .--large
            min-width: 24rem

.--primary
    color: white
    background-color: albion-navy
    border: 1px solid albion-navy

    .icon
        width: 1.4rem
        line-height: 1.6rem
    .icon::before
        background-image: url("/imgs/icons/icon-link--white.png")
    .icon::after
        position: absolute
        background-image: url("/imgs/icons/icon-link--navy.png")
        transition: all .3s linear

.--primary:hover,
.--primary:focus
    color: albion-navy
    background-color: white
    border: 1px solid gray


    // .btn-next
    //     width: 250px
    //     height: 42px
    //     border: 1px solid $sub-blue
    //     border-radius: 13px
    //     color: $white
    //     background-color: $sub-blue
    //     display: block
    //     margin: 30px auto 20px
    //     position: relative
    //     text-decoration: none

    // .btn-next:before
    //     content: ''
    //     width: 0
    //     height: 0
    //     border-style: solid
    //     border-width: 6px 0 6px 8px
    //     border-color: transparent transparent transparent $white
    //     position: absolute
    //     top: 50%
    //     right: 0
    //     margin: -7px 12px 0 0

    // .btn-previous
    //     width: 250px
    //     height: 42px
    //     border: 1px solid $sub-blue
    //     border-radius: 13px
    //     color: $sub-blue
    //     background-color: $white
    //     display: block
    //     margin: 16px auto 30px
    //     position: relative
    //     text-decoration: none

    // .btn-danger
    //     width: 250px
    //     height: 42px
    //     border: 1px solid $danger
    //     border-radius: 13px
    //     color: $white
    //     background-color: $danger
    //     display: block
    //     margin: 30px auto 20px
    //     position: relative
    //     text-decoration: none

    // .btn-danger:before
    //     content: ''
    //     width: 0
    //     height: 0
    //     border-style: solid
    //     border-width: 6px 0 6px 8px
    //     border-color: transparent transparent transparent $white
    //     position: absolute
    //     top: 50%
    //     right: 0
    //     margin: -7px 12px 0 0

    // @media (min-width: 769px)
    //     .btn-next
    //         width: 256px
    //         height: 46px
    //         border: 1px solid $sub-blue
    //         border-radius: 16px
    //         color: $white
    //         background-color: $sub-blue
    //         display: block
    //         margin: 30px auto 16px
    //         position: relative
    //         display: block
    //         text-decoration: none

    //     .btn-next:before
    //         content: ''
    //         width: 0
    //         height: 0
    //         border-style: solid
    //         border-width: 6px 0 6px 8px
    //         border-color: transparent transparent transparent $white
    //         position: absolute
    //         top: 50%
    //         right: 0
    //         margin: -7px 12px 0 0

    //     .btn-next:hover
    //         opacity: 0.8
    //         cursor: pointer

    //     .btn
    //         text-decoration: none

    //     .btn-previous
    //         width: 256px
    //         height: 46px
    //         border: 1px solid $sub-blue
    //         border-radius: 16px
    //         color: $sub-blue
    //         background-color: $white
    //         margin-bottom: 30px

    //     .btn-previous:hover
    //         color: $white
    //         background-color: $sub-blue
    //         cursor: pointer

    //     .btn-danger
    //         width: 256px
    //         height: 46px
    //         border: 1px solid $danger
    //         border-radius: 16px
    //         color: $white
    //         background-color: $danger
    //         display: block
    //         margin: 30px auto 16px
    //         position: relative
    //         display: block
    //         text-decoration: none

    //     .btn-danger:before
    //         content: ''
    //         width: 0
    //         height: 0
    //         border-style: solid
    //         border-width: 6px 0 6px 8px
    //         border-color: transparent transparent transparent $white
    //         position: absolute
    //         top: 50%
    //         right: 0
    //         margin: -7px 12px 0 0

    //     .btn-danger:hover
    //         opacity: 0.8
    //         cursor: pointer
</style>
